// extracted by mini-css-extract-plugin
export var label = "_h9-2";
export var slideContainer = "_h9-0";
export var slider = "_h9-1";